module.exports = __webpack_public_path__ + "static/media/demo4.adbc988d.jpg";